import { render } from "./SafariFrameBlockedNotice.vue?vue&type=template&id=3a3f246a&scoped=true"
import script from "./SafariFrameBlockedNotice.vue?vue&type=script&lang=js"
export * from "./SafariFrameBlockedNotice.vue?vue&type=script&lang=js"

import "./SafariFrameBlockedNotice.vue?vue&type=style&index=0&id=3a3f246a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a3f246a"]])

export default __exports__